import {
	type BoundActions,
	createHook,
	type HookFunction,
	type StoreActionApi
} from 'react-sweet-state';

import type { PromptInputContext } from '@atlassian/conversation-assistant-external-context/types';
import { type SendAnalyticsEvent } from '@atlassian/conversation-assistant-instrumentation/types/analytics';

import type { State } from './State';
import { store } from './store';
import type { UploadedFile } from './UploadedFile';

export const useFileAttachmentsStore: HookFunction<
	UploadedFile[],
	BoundActions<
		State,
		{
			addFiles: (
				key: string,
				files: UploadedFile[],
				sendAnalyticsEvent: SendAnalyticsEvent,
			) => ({ getState, dispatch }: StoreActionApi<State>) => void;
			addExternalContext: (
				key: string,
				context: PromptInputContext[],
			) => ({ getState, dispatch }: StoreActionApi<State>) => void;
			updateFileWithName: (
				key: string,
				fileName: string,
				fileData: Partial<UploadedFile>,
			) => ({ getState, dispatch }: StoreActionApi<State>) => void;
			removeFile: (
				key: string,
				fileName: string,
			) => ({ getState, dispatch }: StoreActionApi<State>) => void;
			removeExternalContext: (
				key: string,
				id: string,
			) => ({ getState, dispatch }: StoreActionApi<State>) => void;
			clearFiles: (key: string) => ({ dispatch, getState }: StoreActionApi<State>) => void;
			clearAttachments: (key: string) => ({ dispatch, getState }: StoreActionApi<State>) => void;
		}
	>,
	string
> = createHook(store, {
	selector: (state, key: string) =>
		[...(state[key]?.attachments?.values() || [])]
			.filter((item) => item.type === 'file')
			.map((item) => item.data as UploadedFile) || [],
});
